<template>
  <DataTable :headers="headers" :path="path" :filterPath="filterPath" actionButtonsName="ExpirationActionButtons"
             :properties="properties" :defaults="defaults" filter>
    <slot slot="before-filters"></slot>
  </DataTable>
</template>

<script>
import { expirationMixin } from '../../../mixins/expirationMixin'
import DataTable from '../../../common/ui/DataTable'

export default {
  mixins: [expirationMixin],

  components: {
    DataTable
  },

  created () {
    this.headers.splice(2, 0, { text: 'Club', value: 'club', sortable: false, filterField: true })
    this.properties.splice(2, 0, 'club')
  }
}
</script>
